(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('FirstTimeLoginController', FirstTimeLoginController);


    FirstTimeLoginController.$inject = ['$translate', '$timeout','GenericService','$http','$state','$scope','$uibModal','$rootScope','$uibModalInstance'];

    function FirstTimeLoginController ($translate, $timeout,GenericService,$http,$state,$scope,$uibModal,$rootScope,$uibModalInstance) {
    	var vm = this;
    	
        vm.registerAccount = {};
        vm.cities = null;
        vm.registerAgain = registerAgain;
    	vm.departments = null;
        vm.otherDepartment=null;
        vm.designations = null;
        vm.otherDesignation=null;
        vm.registerAccount = $scope.$parent.data;
        function getRequiredDesignationAndCityNameData(){
        	GenericService.getSelectBoxData().then(
        				function(data) {
        					var cities=[];
        					var departments=[];
        					var designations=[];
        					angular.forEach(data[0],function(row){
        						cities.push({
        							'cityid':row[0],
        							'cityname':row[1]
        						});
        					});
        					vm.cities = cities;
        					angular.forEach(data[1],function(row){
        						departments.push({
        							'departmentid':row[0],
        							'departmentname':row[1]
        						});
        					});
        					vm.departments = departments;
        					angular.forEach(data[2],function(row){
        						designations.push({
        							'designationid':row[0],
        							'designationname':row[1]
        						});
        					});
        					vm.designations = designations;
	
        				});

        }
        
        getRequiredDesignationAndCityNameData();
        
        $scope.cancelLoginModal = function(){
   		 	$uibModalInstance.dismiss('close');
   		 	$state.go('login');
   		 }
        
        function registerAgain (){

        	var registerAgainsDepartment = vm.registerAccount;

        	GenericService.upadateUserInfo(registerAgainsDepartment).then(function(response){
     
        		if(response == 'Fail'){
        			$state.go('login');
        		}
        		
        		$timeout(
						function() {
							$uibModalInstance
									.dismiss('cancel');
						}, 1000);
        	});
 
        	
        }
        
    	}
    
    })();